var watchlistSelector = {
	label: "Selectionner Liste",
	validationErrors: {
		selectWatchlist: "Vous devez sélectionner une liste"
	}
};
var fr = {
	watchlistSelector: watchlistSelector
};

export { fr as default, watchlistSelector };
